'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageCompareCards = exports.compareCards = undefined;

var _links = require('./links');

var compareCards = exports.compareCards = '\ncompareCards {\n  shortName\n  dtmProductName\n  cardTitle\n  dtm {\n    type\n    tag\n    productName\n  }\n  assets {\n    type\n    url\n    alt\n  }\n  links: ' + _links.encodedLinks + '\n  cardFeatures {\n    content {\n      key\n      header\n      desc {\n        type\n        text\n      }\n    }\n  }\n}\n';

var pageCompareCards = exports.pageCompareCards = '\ncompareCards {\n  header\n  order\n  links: ' + _links.encodedLinks + '\n  qeId\n}\n';